import React, { useEffect, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { useConsultDoctor, useTicketHistory } from "../actionables/store";
import { toast } from "react-toastify";
import { groupSlots } from "modules/utilities/utility";
import secureLocalStorage from "react-secure-storage";
import useAssignedStore from "modules/my_tickets/assigned_tickets/store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import EditTicketInterventionCanvas from './EditTicketInterventionCanvas';
import { CATEGORY_DOCTOR_FLAG } from 'config';
import { isEmpty } from 'lodash';


function CustomerComplaintInterventionBooking({ customerData, setSelectSlot, setFormData, ticket }) {
    const { fetchTicketHistory, ticketData } = useTicketHistory();
    const [reason, setReason] = useState("");
    const slotBooking = false;
    const { setToaster } = useToast();
    const { bookedData, slotData, allSlotData, bookedLoading, allSlotLoading, isLoading, fetchOnboardingData, fetchDoctorSlotData, postDoctorSlotMedicalData } = useConsultDoctor();
    const [doctor, setDoctor] = useState(null);
    const [filterSlotData, setFilterSlotData] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [ticketObject, setTicketObject] = useState(null);
    const [doctorMed, setDoctorMed] = useState(null);
    const [doctorSubCategoryFlag, setDoctorSubCategoryFlag] = useState(false);
    const [show, setShow] = useState(false);

    const ticketId = _.get(ticket, '_id', '');
    const hasTicketData = ticket && !isLoading;
    const sub_category = _.get(ticket, 'sub_category', '');
    const doctorAssignmentCount = _.get(ticket, 'doctor_assignment_count', 0);

    const [medicalInterventionRequired, setMedicalInterventionRequired] = useState(false);
    const action_taker = secureLocalStorage.getItem("id");
    const { updateAssignedData } = useAssignedStore();


    const handleCheckboxChange = () => setMedicalInterventionRequired(!medicalInterventionRequired);

    const handleReasonChange = (event) => setReason(event.target.value);

    const handleShow = () => setShow(true);
    const handleClose = () => {
        setShow(false);
    };

    useEffect(() => {
        if (CATEGORY_DOCTOR_FLAG.includes(_.get(ticket, 'sub_category', null))) {
            setDoctorSubCategoryFlag(true);
        } else {
            setDoctorSubCategoryFlag(false);
        }
    }, [ticket])
    const handleSubmit = (event) => {
        event.preventDefault();
        fetchOnboardingData({
            first_name: customerData?.case?.user?.first_name,
            email: customerData?.case?.user?.email,
            phone_number: customerData?.case?.user?.phone_number, gender: "M"
        }, toast);
        if (doctorSubCategoryFlag === false) {
            fetchDoctorSlotData(ticket.case_id, doctor, sub_category, toast);
        }


    };
    useEffect(() => {
        if (!isEmpty(slotData)) {
            const groupSlot = groupSlots(slotData);
            setFilterSlotData(groupSlot);
        } else {
            setFilterSlotData([]);
        }
    }, [slotData, allSlotData]);

    useEffect(() => {
        setFilterSlotData([]);
    }, [show]);

    const handleDate = (date) => {
        setSelectedDate(date);
        setSelectedSlot(null);
    };

    const handleBookSlot = () => {
        const selectedSlotPayload = {
            from_crm: true,
            case_id: bookedData?.caseId,
            transaction_id: bookedData?.transactionId,
            consult_doctor_fees: "0",
            slot_time: selectedSlot?.slotTime,
            slots: selectedSlot?.slots,
        };
        const payloadEditTicket = {
            comment: {
                type: "customer_complaints",
                commented_by: action_taker,
                description: reason,
            },
            current_assignment: doctor,
            action_taker: action_taker,
            status_code: "3",
            doctor_assignment_count: doctorAssignmentCount + 1,
            slot: selectedSlot
        };

        postDoctorSlotMedicalData(selectedSlotPayload, toast, handleClose, payloadEditTicket, updateAssignedData, ticketId, setSelectSlot, selectedSlot, setToaster);
        setFormData((prevFormData) => ({ ...prevFormData, doctor_intervention_required: medicalInterventionRequired }));
    };
    return (
        <div className="mb-3">
            {hasTicketData && (
                <>
                    <Form.Group
                        className="mb-3 fs-1"
                        style={{ marginTop: "15px" }}
                    >
                        <Form.Check
                            type="checkbox"
                            id="medicalInterventionCheckbox"
                            label={<span className="fs-1">Doctor Intervention Required</span>}
                            checked={medicalInterventionRequired}
                            onChange={(event) => {
                                handleCheckboxChange(event);
                                handleSubmit(event);
                            }}
                        />
                    </Form.Group>

                    {medicalInterventionRequired && (
                        <>
                            <Form.Group
                                className="mb-3"
                                controlId="reasonTextarea"
                            >
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    placeholder="Reason for Doctor Intervention"
                                    onChange={handleReasonChange}
                                    defaultValue={reason}
                                />
                            </Form.Group>
                            <EditTicketInterventionCanvas
                                caseId={ticket?.case_id}
                                name={customerData?.case?.user?.first_name}
                                email={customerData?.case?.user?.email}
                                phone={customerData?.case?.user?.phone_number}
                                tickeId={ticket._id}
                                reason={reason}
                                selectedSlot={selectedSlot}
                                setSelectedSlot={setSelectedSlot}
                                selectedDate={selectedDate}
                                setSelectedDate={setSelectedDate}
                                setTicketObject={setTicketObject}
                                filterSlotData={filterSlotData}
                                setFilterSlotData={setFilterSlotData}
                                doctorMed={doctorMed}
                                setDoctorMed={setDoctorMed}
                                doctorSubCategoryFlag={doctorSubCategoryFlag}
                            />

                            {selectedSlot && (
                                <Button
                                    className="mt-5 py-2 fs-1 w-100"
                                    onClick={handleBookSlot}
                                >
                                    {isLoading ? (
                                        <span className="d-flex flex-row gap-2 justify-content-center">
                                            <Spinner
                                                animation="border"
                                                variant="light"
                                            />
                                            <span>Booking Call Now</span>
                                        </span>
                                    ) : (
                                        <span>Book Call Now</span>
                                    )}
                                </Button>
                            )}
                        </>

                    )}
                </>
            )}
        </div>
    )
}

export default CustomerComplaintInterventionBooking;
